import {nextTick} from "vue";

export function useScroll() {
  async function scrollForEndRightDataTable(id_element) {
    await nextTick();

    const el = document.querySelector(`#${id_element}`)
      .querySelector('#sys-data-table-body');

    if (!el) return;

    el.scrollLeft = el.scrollWidth - el.clientWidth;
  }

  return { scrollForEndRightDataTable }
}
